<template>
  <div
    class="flex items-baseline space-x-1"
    :class="containerClass"
  >
    <span
      v-if="hasAutoshipPromotion || hidePriceForSearchPet"
      :class="labelClass"
    >
      {{ labelText }}
    </span>
    <span
      :class="{
        'line-through text-neutral-500': hasAutoshipPromotion,
        [slotClass]: hasAutoshipPromotion || (hidePriceForSearchPet && !hasAutoshipPromotion),
      }"
    >
      <slot />
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'VetsterDiscount',

  props: {
    containerClass: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    slotClass: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters('promoCodes', ['hasAutoshipPromotion']),
    ...mapGetters('search', ['hidePriceForSearchPet']),
    labelText() {
      if (this.hasAutoshipPromotion) {
        return this.$t('search.free');
      }

      return this.$t('search.included');
    },
  },
};
</script>
